<form [formGroup]="form" (ngSubmit)="onSubmitForm($event)">
  <div class="form-group pt-2" formGroupName="sourceName">
    <label for="sourceName">{{ 'Settings::AmazonS3IntegrationSourceName' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="sourceName"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="organizationId">
    <label for="organizationId">{{ 'Settings::AmazonS3IntegrationOrganizationId' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="organizationId"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="clientId">
    <label for="clientId">{{ 'Settings::AmazonS3IntegrationClientId' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="clientId" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="clientSecret">
    <label for="clientSecret">
      {{ 'Settings::AmazonS3IntegrationClientSecret' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="clientSecret"
      [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="region">
    <label for="region">
      {{ 'Settings::AmazonS3IntegrationRegion' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="region"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="bucketName">
    <label for="bucketName">{{ 'Settings::AmazonS3IntegrationBucketName' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="bucketName" formControlName="value" />
  </div>
   <div class="form-group pt-2" formGroupName="outputBucketName">
    <label for="outputBucketName">{{ 'Settings::AmazonS3IntegrationOutputBucketName' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="outputBucketName" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="templatePath">
    <label for="templatePath">{{ 'Settings::AmazonS3IntegrationTemplatePath' | abpLocalization }}</label>
    <input type="text" placeholder="recordings-voice/{year}/{month}/{day}/{hour}/{aqmId}_{callID}_{callsequence}_{RecordingId}.mp3" class="form-control form-control-sm" id="templatePath" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="outputTemplatePath">
    <label for="outputTemplatePath">{{ 'Settings::AmazonS3IntegrationOutputTemplatePath' | abpLocalization }}</label>
    <input type="text" placeholder="transcripted-output/{year}/{month}/{day}/{hour}/{aqmId}_{callID}_{callsequence}_{RecordingId}.json" class="form-control form-control-sm" id="outputTemplatePath" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="kinesisRegion">
    <label for="kinesisRegion">{{ 'Settings::AmazonS3IntegrationKinesisRegion' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="kinesisRegion" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="kinesisStreamName">
    <label for="kinesisStreamName">{{ 'Settings::AmazonS3IntegrationKinesisStreamName' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="kinesisStreamName" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="partnerRoleArn">
    <label for="partnerRoleArn">{{ 'Settings::AmazonS3IntegrationPartnerRoleArn' | abpLocalization }}</label>
    <input type="text" placeholder="arn:aws:iam::123456789012:role/RoleName" class="form-control form-control-sm" id="partnerRoleArn" formControlName="value" />
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3" [disabled]="!form.valid">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
